import request from '@/utils/request'

export const feedbackSeed = (data) => {
  return request({
    url: '/erp/mshop/feedback',
    method: 'post',
    data
  })
}